import type { Res, UpdateUserEmailReq, UpdateUserEmailRes } from '@/types/api'

import request, { baseOrigin } from './request'
import { AxiosRequestConfig } from 'axios'
import type { ResWithMeta, ISmsReq, IPhoneLoginReq, IBindPhoneReq } from '@/types/api'

export const loginApi = async (params) => {
  return request.post('/users/login', params, {
    skipCodeCheck: true
  })
}

// 退出登陆
export const logoutApi = async () => {
  return request.post('/users/logout')
}

export const registerApi = async (params) => {
  return request.post('/users/signup', params)
}

export const modifyApi = async (params) => {
  return request.post('/users/reset-password', params)
}

//发送邮件找回密码
export const forgotApi = async (params: UpdateUserEmailReq) => {
  return request.post<Res<UpdateUserEmailRes>>('/users/send-email', params)
}

// 获取token
export const getGoogleLoginToken = async ({ params }) => {
  return request.get(`/auth/google/callback`, {
    params
  })
}

export const getWeChatQrcode = async () => {
  return request.get(`/wechat/qrcode`)
}

//引导信息填写
export const putInformation = async (params) => {
  return request.put(`/users/onboarding`, params)
}

// 查看微信登录状态
export const checkWeChatBind = async (params) => {
  return request.get(`/wechat/check`, {
    params
  })
}

// 检查邀请码的状态
export const checkInviteCode = async ({ code }) => {
  return request.get(`/users/invites/${code}/check`)
}

// 获取短信验证码
export const postSmsApi = (data: ISmsReq, config?: AxiosRequestConfig) => {
  return request.post<ResWithMeta<any>>(`/users/send-sms`, { ...data, ...config })
}

// 手机号登录
export const postPhoneLoginApi = (data: IPhoneLoginReq, config?: AxiosRequestConfig) => {
  return request.post<ResWithMeta<any>>(`/users/sms-login`, { ...data, ...config })
}

// 绑定手机号
export const postBindPhoneApi = (data: IBindPhoneReq, config?: AxiosRequestConfig) => {
  return request.post<ResWithMeta<any>>(`/users/bind-phone`, { ...data, ...config })
}
